import { CurrentUser } from 'contexts/userContext';
import { useCallback, useMemo } from 'react';

type permissionElement = string;

export const useCheckUserPermissions = (currentUser: CurrentUser | null) => {
  const permissionsSet = useMemo(() => {
    if (!currentUser) return new Set<permissionElement>();
    if (currentUser.is_admin) {
      return new Set<permissionElement>(['*']);
    }
    return new Set(currentUser.permissions.map(permission => permission.element));
  }, [currentUser]);

  const hasPermission = useCallback((permission:permissionElement) => {
    return permissionsSet.has('*') || permissionsSet.has(permission);
  }, [permissionsSet]);

  return { hasPermission };
};